module.exports = __webpack_public_path__ + "media/bootstrap-icons/circle-half-a0306179.svg";